import { useEffect } from "react";
import { useDebounce } from "./index";

interface IProps {
  standW?: number;
  basicFontSize?: number;
  onlyCurPage?: boolean;
}

const useResizeFont = (props?: IProps) => {
  const { standW = 1920, basicFontSize = 16, onlyCurPage = true } = props || {};

  const getElementFontSize = () => {
    const docEl = document.documentElement;
    let { clientWidth } = docEl;
    if (clientWidth < 300) {
      clientWidth = 300;
    }
    if (!clientWidth) return;
    docEl.style.fontSize = basicFontSize * (clientWidth / standW) + "px";
  };

  const run = useDebounce(() => {
    getElementFontSize();
    if (!document.addEventListener) return;
    window.addEventListener("resize", run, false);
  }, 400);

  useEffect(() => {
    getElementFontSize();
    run();
    return () => {
      if (onlyCurPage) {
        document.documentElement.removeAttribute("style");
      }
      window.removeEventListener("resize", run, false);
    };
  }, [run]);
};

export default useResizeFont;
